import {
  ROLES,
  type Role,
  useMyAdherentSummary,
  useSsoService,
} from "@pharmupp/p3-front-commons"
import { type ReactNode, useEffect } from "react"
import TagManager from "react-gtm-module"

const EXPOSED_ROLES: Role[] = [
  ROLES.ADMIN,
  ROLES.UPP_PRESIDENT,
  ROLES.UPP_REPRESENTATIVE,
  ROLES.ADHERENT_HOLDER,
  ROLES.ADHERENT_TEAM,
  ROLES.EXTERN_CONTACT_LABORATORY,
]
export const TrackingInit = ({ children }: { children: ReactNode }) => {
  const sso = useSsoService()
  const roles = sso.getRoles()
  const ids = sso.getIds()
  const userFullName = sso.getFullName()

  const { summary: adherentSummary } = useMyAdherentSummary()

  // Sends role stat to GTM
  useEffect(() => {
    const [user_role] = (roles || [])
      .filter((role) => EXPOSED_ROLES.includes(role))
      .sort((a, b) => EXPOSED_ROLES.indexOf(a) - EXPOSED_ROLES.indexOf(b))

    // ⚠️ each dataLayer variable must be defined in GA tag in GTM and inside GA custom user metric
    TagManager.dataLayer({
      dataLayer: {
        event: "login",
        user_role,
        user_id: ids?.keycloakId,
      },
    })
  }, [ids?.keycloakId, roles])

  // ChayAll init
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "init-chayall",
        ...(ids?.chayallId && { ChayAllSessionId: ids?.chayallId }),
      },
    })
  }, [ids?.chayallId])

  return (
    <>
      {children}
      <input
        type="hidden"
        name="third-party-exposition-user-fullname"
        value={userFullName}
      />
      {!!adherentSummary && (
        <input
          type="hidden"
          name="third-party-exposition-adherent-name"
          value={adherentSummary.name}
        />
      )}
    </>
  )
}
